export enum MySettingsTab {
  AUTOPILOT = 'autoPilot',
  STARTENDTIME = 'startEndTime',
  SMARTSUGGESTION = 'smartSuggestion'
}
